<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useImpersonation } from '@/composables/useImpersonation'

const authStore = useAuthStore()
const { endImpersonation } = useImpersonation()
</script>

<template>
  <v-banner
    v-if="authStore.isImpersonation"
    color="warning"
    sticky
    lines="one"
    class="impersonation-banner"
  >
    <template #prepend>
      <v-icon>mdi-account-switch</v-icon>
    </template>

    <span>
      Вы вошли как <strong>{{ authStore.fullName }}</strong>
      <span class="text-medium-emphasis ml-2">
        (от имени {{ authStore.impersonatedBy?.name }})
      </span>
    </span>

    <template #actions>
      <v-btn
        variant="tonal"
        size="small"
        @click="endImpersonation"
      >
        <v-icon start>
          mdi-close
        </v-icon>
        Закрыть вкладку
      </v-btn>
    </template>
  </v-banner>
</template>

<style scoped>
.impersonation-banner {
  z-index: 1000;
}
</style>
